var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPension(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6462 17.4663C21.5218 18.4266 20.2741 19.2146 18.9454 19.8162L17.7545 16.391H19.4461V15.7455C19.4461 13.7141 17.7935 12.0615 15.7621 12.0615H9.8184L9.42845 10.7702H15.1483V9.47913H9.0386L7.01932 2.79283L7.00857 2.75725L6.99375 2.72309C6.59659 1.80549 5.86362 1.1032 4.92982 0.745788C3.99602 0.388416 2.98149 0.421674 2.07308 0.839547L1.56665 1.07248L6.05677 16.3909H7.36745L6.1718 19.868C4.80006 19.2602 3.51288 18.4542 2.35603 17.4662L1.51758 18.448C4.57705 21.061 8.47777 22.5 12.5012 22.5C16.5246 22.5 20.4253 21.061 23.4847 18.448L22.6462 17.4663ZM12.5011 21.2089C10.7433 21.209 9.01088 20.9111 7.37398 20.3422L8.7327 16.391H16.3874L17.7466 20.3C16.075 20.8961 14.3015 21.2089 12.5011 21.2089Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPension);
export default __webpack_public_path__ + "static/media/pension.a4d92433d9a10b1f3fb477cd5f0035bc.svg";
export { ForwardRef as ReactComponent };